import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoRequestExpensessGetReqImple } from "mediadept-common/src/common/dto/DtoRequestExpensessGetReqImple";
import { DtoRequestExpensessGetResImple } from "mediadept-common/src/common/dto/DtoRequestExpensessGetResImple";
import { DtoRequestExpensessPostReq } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessPostReq";
import { DtoRequestExpensessPostRes } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessPostRes";
import { DtoRequestExpensessPutReq } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessPutReq";
import { DtoRequestExpensessPutRes } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessPutRes";
import { DtoRequestExpensessDeleteReq } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessDeleteReq";
import { DtoRequestExpensessDeleteRes } from "mediadept-common/src/common/dto/abst/DtoRequestExpensessDeleteRes";

export class Cl_requestexpenses {
  public static async getList(
    dto: DtoRequestExpensessGetReqImple
  ): Promise<DtoRequestExpensessGetResImple> {
    return Object.assign(
      new DtoRequestExpensessGetResImple(),
      await CallAPI.getRequest(
        "/requestexpensess?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoRequestExpensessGetReqImple
  ): Promise<DtoRequestExpensessGetResImple> {
    return Object.assign(
      new DtoRequestExpensessGetResImple(),
      await CallAPI.getRequest("/requestexpensess/" + dto.c_request_expenses_id)
    );
  }

  public static async post(
    dto: DtoRequestExpensessPostReq
  ): Promise<DtoRequestExpensessPostRes> {
    return Object.assign(
      new DtoRequestExpensessPostRes(),
      await CallAPI.postRequest("/requestexpensess", dto)
    );
  }

  public static async put(
    dto: DtoRequestExpensessPutReq
  ): Promise<DtoRequestExpensessPutRes> {
    return Object.assign(
      new DtoRequestExpensessPutRes(),
      await CallAPI.putRequest(
        "/requestexpensess/" + dto.c_request_expenses_id,
        dto
      )
    );
  }

  public static async del(
    dto: DtoRequestExpensessDeleteReq
  ): Promise<DtoRequestExpensessDeleteRes> {
    return Object.assign(
      new DtoRequestExpensessDeleteRes(),
      await CallAPI.deleteRequest(
        "/requestexpensess?" + Cl_common.cnvObj2GetParam(dto)
      )
    );
  }
}
